/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a paid company is in its renewal cycle, derived from NextSubscriptionRenewalDate.
 * @export
 */
export const WebApiModelsEnumerationTypesSubscriptionStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type WebApiModelsEnumerationTypesSubscriptionStatus = typeof WebApiModelsEnumerationTypesSubscriptionStatus[keyof typeof WebApiModelsEnumerationTypesSubscriptionStatus];


export function WebApiModelsEnumerationTypesSubscriptionStatusFromJSON(json: any): WebApiModelsEnumerationTypesSubscriptionStatus {
    return WebApiModelsEnumerationTypesSubscriptionStatusFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesSubscriptionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesSubscriptionStatus {
    return json as WebApiModelsEnumerationTypesSubscriptionStatus;
}

export function WebApiModelsEnumerationTypesSubscriptionStatusToJSON(value?: WebApiModelsEnumerationTypesSubscriptionStatus | null): any {
    return value as any;
}

